import { useState, useEffect } from 'react';

export default function useGet(url, initial = false, urlIdentifier = null) {
    const [error, setError] = useState();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const call = async() => {
        setLoading(true);
        try {
            const response = await fetch(`${urlIdentifier === 'loan' ? process.env.REACT_APP_LOAN_API_URL : process.env.REACT_APP_API_URL}/${url}`);
            const result = await response.json();
            if (response.ok) {
                setData(result);
            } else {
                setError(result);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (initial) {
            call();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [data, error, loading, call];
}